"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Ala = {
  fullName: 'Alanine',
  singleLetterCode: 'A',
  threeLetterCode: 'ALA'
};
var Arg = {
  fullName: 'Arginine',
  singleLetterCode: 'R',
  threeLetterCode: 'ARG'
};
var Asn = {
  fullName: 'Asparagine',
  singleLetterCode: 'N',
  threeLetterCode: 'ASN'
};
var Asp = {
  fullName: 'Aspartic Acid',
  singleLetterCode: 'D',
  threeLetterCode: 'ASP'
};
var Cys = {
  fullName: 'Cysteine',
  singleLetterCode: 'C',
  threeLetterCode: 'CYS'
};
var Gln = {
  fullName: 'Glutamine',
  singleLetterCode: 'Q',
  threeLetterCode: 'GLN'
};
var Glu = {
  fullName: 'Glutamic Acid',
  singleLetterCode: 'E',
  threeLetterCode: 'GLU'
};
var Gly = {
  fullName: 'Glycine',
  singleLetterCode: 'G',
  threeLetterCode: 'GLY'
};
var His = {
  fullName: 'Histidine',
  singleLetterCode: 'H',
  threeLetterCode: 'HIS'
};
var Ile = {
  fullName: 'Isoleucine',
  singleLetterCode: 'I',
  threeLetterCode: 'ILE'
};
var Leu = {
  fullName: 'Leucine',
  singleLetterCode: 'L',
  threeLetterCode: 'LEU'
};
var Lys = {
  fullName: 'Lysine',
  singleLetterCode: 'K',
  threeLetterCode: 'LYS'
};
var Met = {
  fullName: 'Methionine',
  singleLetterCode: 'M',
  threeLetterCode: 'MET'
};
var Phe = {
  fullName: 'Phenylalanine',
  singleLetterCode: 'F',
  threeLetterCode: 'PHE'
};
var Pro = {
  fullName: 'Proline',
  singleLetterCode: 'P',
  threeLetterCode: 'PRO'
};
var Ser = {
  fullName: 'Serine',
  singleLetterCode: 'S',
  threeLetterCode: 'SER'
};
var Thr = {
  fullName: 'Threonine',
  singleLetterCode: 'T',
  threeLetterCode: 'THR'
};
var Trp = {
  fullName: 'Tryptophan',
  singleLetterCode: 'W',
  threeLetterCode: 'TRP'
};
var Tyr = {
  fullName: 'Tyrosine',
  singleLetterCode: 'Y',
  threeLetterCode: 'TYR'
};
var Val = {
  fullName: 'Valine',
  singleLetterCode: 'V',
  threeLetterCode: 'VAL'
}; // tslint:disable:object-literal-sort-keys

exports.AMINO_ACIDS_BY_SINGLE_LETTER_CODE = {
  A: Ala,
  R: Arg,
  N: Asn,
  D: Asp,
  C: Cys,
  Q: Gln,
  E: Glu,
  G: Gly,
  H: His,
  I: Ile,
  L: Leu,
  K: Lys,
  M: Met,
  F: Phe,
  P: Pro,
  S: Ser,
  T: Thr,
  W: Trp,
  Y: Tyr,
  V: Val
}; // tslint:enable:object-literal-sort-keys

exports.AMINO_ACIDS_BY_THREE_LETTER_CODE = {
  ALA: Ala,
  ARG: Arg,
  ASN: Asn,
  ASP: Asp,
  CYS: Cys,
  GLN: Gln,
  GLU: Glu,
  GLY: Gly,
  HIS: His,
  ILE: Ile,
  LEU: Leu,
  LYS: Lys,
  MET: Met,
  PHE: Phe,
  PRO: Pro,
  SER: Ser,
  THR: Thr,
  TRP: Trp,
  TYR: Tyr,
  VAL: Val
};
exports.AMINO_ACIDS = [Ala, Arg, Asn, Asp, Cys, Gln, Glu, Gly, His, Ile, Leu, Lys, Met, Phe, Pro, Ser, Thr, Trp, Tyr, Val];

exports.getPDBAndCouplingMismatch = function (pdbData, couplingScores) {
  var pdbSequence = pdbData.sequence;
  var couplingSequence = couplingScores.sequence;
  var mismatches = exports.getSequenceMismatch(pdbSequence, couplingSequence);

  if (mismatches.length === 0) {
    return pdbData.getResidueNumberingMismatches(couplingScores);
  }

  return mismatches;
};

exports.getSequenceMismatch = function (firstSequence, secondSequence) {
  var mismatches = new Array();

  if (firstSequence.length === secondSequence.length) {
    for (var i = 0; i < firstSequence.length; ++i) {
      var couplingAminoAcid = firstSequence[i];
      var pdbAminoAcid = secondSequence[i];

      if (couplingAminoAcid !== pdbAminoAcid) {
        mismatches.push({
          firstAminoAcid: exports.AMINO_ACIDS_BY_SINGLE_LETTER_CODE[couplingAminoAcid],
          resno: i,
          secondAminoAcid: exports.AMINO_ACIDS_BY_SINGLE_LETTER_CODE[pdbAminoAcid]
        });
      }
    }
  }

  return mismatches;
};